import { Box, Tab, Tabs } from "@mui/material"
import { DriverTabPanelEnum } from "../../../enums/driverTabPanelEnum"
import { TABLE_HEADER_BACKGROUND_COLOR } from "../../../constants/colors"
import { useTranslation } from "react-i18next"

interface Props {
    value: DriverTabPanelEnum,
    onChange: (newValue: DriverTabPanelEnum) => void
}

const TabPanelOnlineDriverPage = ({ value, onChange }: Props) => {
    const { t } = useTranslation('global');
    return (
        <Box sx={{ width: '100%', backgroundColor: TABLE_HEADER_BACKGROUND_COLOR }}>
            <Box sx={{ borderBottom: 'none', borderColor: 'divider' }}>
                <Tabs value={value} onChange={(e: any, newValue: DriverTabPanelEnum) => {
                    onChange(newValue)
                }} variant="scrollable"
                    scrollButtons="auto">
                    <Tab label={`${t("driverUser_page.ALL")}`} value={DriverTabPanelEnum.All} sx={{ textTransform: 'none' }} />
                    <Tab label={`${t("driverUser_page.Online")}`} value={DriverTabPanelEnum.Active} sx={{ textTransform: 'none' }} />
                    <Tab label={`${t("driverUser_page.Offline")}`} value={DriverTabPanelEnum.Inactive} sx={{ textTransform: 'none' }} />
                </Tabs>
            </Box>
        </Box>
    )
}
export default TabPanelOnlineDriverPage